// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";

function localeStrings_achBankDebitTerms(param) {
  return `Your ACH Debit Authorization will be set up now, but we'll confirm the amount and let you know before future payments are taken.`;
}

function localeStrings_sepaDebitTerms(str) {
  return `By providing your payment information and confirming to this mandate form, you authorise (A) ` + str + `, the Creditor and/or our payment service provider(s) to send instructions to your bank to debit your account and (B) your bank to debit your account in accordance with the instructions from ` + str + `. As part of your rights, you are entitled to a refund from your bank under the terms and conditions of your agreement with your bank. A refund must be claimed within 8 weeks starting from the date on which your account was debited. Your rights are explained in a statement that you can obtain from your bank.`;
}

function localeStrings_cardTerms(str) {
  return `By providing your card information, you allow ` + str + ` to charge your card for future payments in accordance with their terms.`;
}

function localeStrings_surchargeMsgAmount(currency, str) {
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      `A surcharge amount of` + Utils$OrcaPaymentPage.nbsp,
      JsxRuntime.jsx("strong", {
        children: currency + ` ` + str
      }),
      Utils$OrcaPaymentPage.nbsp + `will be applied for this transaction`
    ]
  });
}

function localeStrings_shortSurchargeMessage(currency, amount) {
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      `Fee :` + Utils$OrcaPaymentPage.nbsp,
      JsxRuntime.jsx("strong", {
        children: currency + ` ` + amount
      })
    ]
  });
}

function localeStrings_surchargeMsgAmountForCard(currency, str) {
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      `A surcharge amount of upto` + Utils$OrcaPaymentPage.nbsp,
      JsxRuntime.jsx("strong", {
        children: currency + ` ` + str
      }),
      Utils$OrcaPaymentPage.nbsp + `will be applied for this transaction`
    ]
  });
}

function localeStrings_nameEmptyText(str) {
  return `Please provide your ` + str;
}

function localeStrings_completeNameEmptyText(str) {
  return `Please provide your complete ` + str;
}

function localeStrings_cardBrandConfiguredErrorText(str) {
  return str + ` is not supported at the moment.`;
}

function localeStrings_formFundsCreditInfoText(pmLabel) {
  return `Your funds will be credited in the selected ` + pmLabel + `.`;
}

function localeStrings_formSubheaderAccountText(pmLabel) {
  return `Your ` + pmLabel;
}

function localeStrings_formHeaderReviewTabLayoutText(pmLabel) {
  return `Review your ` + pmLabel + ` details`;
}

function localeStrings_formHeaderBankText(bankTransferType) {
  return `Enter ` + bankTransferType + ` bank details`;
}

function localeStrings_formHeaderWalletText(walletTransferType) {
  return `Enter ` + walletTransferType + ` wallet details`;
}

function localeStrings_linkRedirectionText(seconds) {
  return `Redirecting in ` + seconds.toString() + ` seconds ...`;
}

function localeStrings_linkExpiryInfo(expiry) {
  return `Link expires on: ` + expiry;
}

function localeStrings_payoutFromText(merchant) {
  return `Payout from ` + merchant;
}

function localeStrings_giftCardPaymentRemainingMessage(currency, amount) {
  return `Pay remaining ` + currency + ` ` + amount + ` with other payment method below.`;
}

let localeStrings = {
  locale: "en",
  cardNumberLabel: "Card Number",
  localeDirection: "ltr",
  inValidCardErrorText: "Card number is invalid.",
  inCompleteCVCErrorText: "Your card's security code is incomplete.",
  inValidExpiryErrorText: "Card expiry is invalid.",
  inCompleteExpiryErrorText: "Your card's expiration date is incomplete.",
  enterValidCardNumberErrorText: "Please enter a valid card number.",
  pastExpiryErrorText: "Your card's expiration year is in the past.",
  poweredBy: "Powered By Hyperswitch",
  validThruText: "Expiry",
  sortCodeText: "Sort Code",
  cvcTextLabel: "CVC",
  emailLabel: "Email",
  ibanEmptyText: "IBAN cannot be empty",
  ibanInvalidText: "Please enter valid IBAN",
  emailEmptyText: "Email cannot be empty",
  emailInvalidText: "Invalid email address",
  accountNumberText: "Account Number",
  accountNumberInvalidText: "Account number is invalid",
  sortCodeInvalidText: "Sort code is invalid",
  fullNameLabel: "Full name",
  line1Label: "Address line 1",
  line1Placeholder: "Street address",
  line1EmptyText: "Address line 1 cannot be empty",
  line2Label: "Address line 2",
  line2Placeholder: "Apt., unit number, etc",
  line2EmptyText: "Address line 2 cannot be empty",
  cityLabel: "City",
  cityEmptyText: "City cannot be empty",
  postalCodeLabel: "Postal Code",
  postalCodeEmptyText: "Postal code cannot be empty",
  postalCodeInvalidText: "Invalid postal code",
  stateLabel: "State",
  stateEmptyText: "State cannot be empty",
  fullNamePlaceholder: "First and last name",
  countryLabel: "Country",
  currencyLabel: "Currency",
  bankLabel: "Select Bank",
  documentTypeLabel: "Doc Type",
  redirectText: "After submitting your order, you will be redirected to securely complete your purchase.",
  bankDetailsText: "After submitting these details, you will get bank account information to make payment. Please make sure to take a note of it.",
  orPayUsing: "Or pay using",
  addNewCard: "Add credit/debit card",
  useExisitingSavedCards: "Use saved debit/credit cards",
  saveCardDetails: "Save card details",
  addBankAccount: "Add bank account",
  achBankDebitTerms: localeStrings_achBankDebitTerms,
  sepaDebitTerms: localeStrings_sepaDebitTerms,
  becsDebitTerms: `By providing your bank account details and confirming this payment, you agree to this Direct Debit Request and the Direct Debit Request service agreement and authorise Hyperswitch Payments Australia Pty Ltd ACN 160 180 343 Direct Debit User ID number 507156 (“Hyperswitch”) to debit your account through the Bulk Electronic Clearing System (BECS) on behalf of Hyperswitch Payment Widget (the "Merchant") for any amounts separately communicated to you by the Merchant. You certify that you are either an account holder or an authorised signatory on the account listed above.`,
  cardTerms: localeStrings_cardTerms,
  payNowButton: "Pay Now",
  cardNumberEmptyText: "Card Number cannot be empty",
  cardExpiryDateEmptyText: "Card expiry date cannot be empty",
  cvcNumberEmptyText: "CVC Number cannot be empty",
  enterFieldsText: "Please enter all fields",
  enterValidDetailsText: "Please enter valid details",
  selectPaymentMethodText: "Please select a payment method and try again",
  card: "Card",
  surchargeMsgAmount: localeStrings_surchargeMsgAmount,
  shortSurchargeMessage: localeStrings_shortSurchargeMessage,
  surchargeMsgAmountForCard: localeStrings_surchargeMsgAmountForCard,
  surchargeMsgAmountForOneClickWallets: "Additional fee applicable",
  billingNameLabel: "Billing name",
  billingNamePlaceholder: "First and last name",
  cardHolderName: "Card Holder Name",
  on: "on",
  and: "and",
  nameEmptyText: localeStrings_nameEmptyText,
  completeNameEmptyText: localeStrings_completeNameEmptyText,
  billingDetailsText: "Billing Details",
  socialSecurityNumberLabel: "Social Security Number",
  saveWalletDetails: "Wallets details will be saved upon selection",
  newPaymentMethods: "New payment methods",
  useExistingPaymentMethods: "Use saved payment methods",
  cardNickname: "Card Nickname",
  nicknamePlaceholder: "Card Nickname (Optional)",
  cardExpiredText: `This card has expired`,
  cardHeader: `Card information`,
  cardBrandConfiguredErrorText: localeStrings_cardBrandConfiguredErrorText,
  cardNotEligibleText: "This card is not accepted for this payment",
  currencyNetwork: `Currency Networks`,
  expiryPlaceholder: `MM / YY`,
  dateOfBirth: `Date of Birth`,
  vpaIdLabel: "Vpa Id",
  vpaIdEmptyText: "Vpa Id cannot be empty",
  vpaIdInvalidText: "Invalid Vpa Id address",
  dateofBirthRequiredText: `Date of birth is required`,
  dateOfBirthInvalidText: `Age should be greater than or equal to 18 years`,
  dateOfBirthPlaceholderText: `Enter Date of Birth`,
  formFundsInfoText: `Funds will be credited to this account`,
  formFundsCreditInfoText: localeStrings_formFundsCreditInfoText,
  formEditText: `Edit`,
  formSaveText: `Save`,
  formSubmitText: `Submit`,
  formSubmittingText: `Submitting`,
  formSubheaderBillingDetailsText: `Enter your billing address`,
  formSubheaderCardText: `Your card details`,
  formSubheaderAccountText: localeStrings_formSubheaderAccountText,
  formHeaderReviewText: `Review`,
  formHeaderReviewTabLayoutText: localeStrings_formHeaderReviewTabLayoutText,
  formHeaderBankText: localeStrings_formHeaderBankText,
  formHeaderWalletText: localeStrings_formHeaderWalletText,
  formHeaderEnterCardText: `Enter card details`,
  formHeaderSelectBankText: `Select a bank method`,
  formHeaderSelectWalletText: `Select a wallet`,
  formHeaderSelectAccountText: `Select an account for payouts`,
  formFieldACHRoutingNumberLabel: `Routing Number`,
  formFieldSepaIbanLabel: `International Bank Account Number (IBAN)`,
  formFieldSepaBicLabel: `Bank Identifier Code (Optional)`,
  formFieldPixIdLabel: `Pix ID`,
  formFieldBankAccountNumberLabel: `Bank Account Number`,
  formFieldPhoneNumberLabel: `Phone Number`,
  formFieldCountryCodeLabel: `Country Code (Optional)`,
  formFieldCountryCodeRequiredLabel: `Country Code`,
  formFieldBankNameLabel: `Bank Name (Optional)`,
  formFieldBankCityLabel: `Bank City (Optional)`,
  formFieldCardHoldernamePlaceholder: `Your Name`,
  formFieldBankNamePlaceholder: `Bank Name`,
  formFieldBankCityPlaceholder: `Bank City`,
  formFieldEmailPlaceholder: `Your Email`,
  formFieldPhoneNumberPlaceholder: `Your Phone`,
  formFieldInvalidRoutingNumber: `Routing number is invalid.`,
  infoCardRefId: `Ref Id`,
  infoCardErrCode: `Error Code`,
  infoCardErrMsg: `Error Message`,
  infoCardErrReason: `Reason`,
  linkRedirectionText: localeStrings_linkRedirectionText,
  linkExpiryInfo: localeStrings_linkExpiryInfo,
  payoutFromText: localeStrings_payoutFromText,
  payoutStatusFailedMessage: `Failed to process your payout. Please check with your provider for more details.`,
  payoutStatusPendingMessage: `Your payout should be processed within 2-3 business days.`,
  payoutStatusSuccessMessage: `Your payout was successful. Funds were deposited in your selected payment mode.`,
  payoutStatusFailedText: `Payout Failed`,
  payoutStatusPendingText: `Payout Processing`,
  payoutStatusSuccessText: `Payout Successful`,
  pixCNPJInvalidText: `Invalid Pix CNPJ`,
  pixCNPJEmptyText: `Pix CNPJ cannot be empty`,
  pixCNPJLabel: `Pix CNPJ`,
  pixCNPJPlaceholder: `Enter Pix CNPJ`,
  pixCPFInvalidText: `Invalid Pix CPF`,
  pixCPFEmptyText: `Pix CPF cannot be empty`,
  pixCPFLabel: `Pix CPF`,
  pixCPFPlaceholder: `Enter Pix CPF`,
  pixKeyEmptyText: `Pix key cannot be empty`,
  pixKeyLabel: `Pix key`,
  pixKeyPlaceholder: `Enter Pix key`,
  sourceBankAccountIdEmptyText: `Source Bank Account ID cannot be empty`,
  invalidCardHolderNameError: `Card Holder's name cannot have digits`,
  cardHolderNameRequiredText: `Card Holder's name required`,
  lastNameRequiredText: `Last Name Required`,
  mandatoryFieldText: `This field is mandatory`,
  phoneInvalidText: `Enter a valid phone number`,
  blikCodeInvalidText: `Enter a valid 6-digit Blik code`,
  invalidNickNameError: `Nickname cannot have more than 2 digits`,
  expiry: `expiry`,
  payment_methods_afterpay_clearpay: `After Pay`,
  payment_methods_google_pay: `Google Pay`,
  payment_methods_apple_pay: `Apple Pay`,
  payment_methods_samsung_pay: "Samsung Pay",
  payment_methods_mb_way: `Mb Way`,
  payment_methods_mobile_pay: `Mobile Pay`,
  payment_methods_ali_pay: `Alipay`,
  payment_methods_ali_pay_hk: `AlipayHK`,
  payment_methods_we_chat_pay: `WeChat`,
  payment_methods_duit_now: `DuitNow`,
  payment_methods_revolut_pay: `Revolut Pay`,
  payment_methods_affirm: `Affirm`,
  payment_methods_pay_safe_card: `PaysafeCard`,
  payment_methods_crypto_currency: `Crypto`,
  payment_methods_card: `Card`,
  payment_methods_klarna: `Klarna`,
  payment_methods_sofort: `Sofort`,
  payment_methods_ach_transfer: `ACH Bank Transfer`,
  payment_methods_bacs_transfer: `BACS Bank Transfer`,
  payment_methods_sepa_bank_transfer: `SEPA Bank Transfer`,
  payment_methods_instant_bank_transfer: `Instant Bank Transfer`,
  payment_methods_instant_bank_transfer_finland: `Instant Bank Transfer Finland`,
  payment_methods_instant_bank_transfer_poland: `Instant Bank Transfer Poland`,
  payment_methods_sepa_debit: `SEPA Debit`,
  payment_methods_giropay: `GiroPay`,
  payment_methods_eps: `EPS`,
  payment_methods_walley: `Walley`,
  payment_methods_pay_bright: `Pay Bright`,
  payment_methods_ach_debit: `ACH Debit`,
  payment_methods_bacs_debit: `BACS Debit`,
  payment_methods_becs_debit: `BECS Debit`,
  payment_methods_blik: `Blik`,
  payment_methods_trustly: `Trustly`,
  payment_methods_bancontact_card: `Bancontact Card`,
  payment_methods_online_banking_czech_republic: `Online Banking CzechR`,
  payment_methods_online_banking_slovakia: `Online Banking Slovakia`,
  payment_methods_online_banking_finland: `Online Banking Finland`,
  payment_methods_online_banking_poland: `Online Banking Poland`,
  payment_methods_ideal: `iDEAL | Wero`,
  payment_methods_ban_connect: `Ban Connect`,
  payment_methods_ach_bank_debit: `ACH Direct Debit`,
  payment_methods_przelewy24: `Przelewy24`,
  payment_methods_interac: `Interac`,
  payment_methods_twint: `Twint`,
  payment_methods_vipps: `Vipps`,
  payment_methods_dana: `Dana`,
  payment_methods_go_pay: `Go Pay`,
  payment_methods_kakao_pay: `Kakao Pay`,
  payment_methods_gcash: `GCash`,
  payment_methods_momo: `Momo`,
  payment_methods_touch_n_go: `Touch N Go`,
  payment_methods_bizum: `Bizum`,
  payment_methods_classic: `Cash / Voucher`,
  payment_methods_online_banking_fpx: `Online Banking Fpx`,
  payment_methods_online_banking_thailand: `Online Banking Thailand`,
  payment_methods_alma: `Alma`,
  payment_methods_atome: `Atome`,
  payment_methods_multibanco_transfer: `Multibanco`,
  payment_methods_card_redirect: `Card`,
  payment_methods_pay_by_bank: `Pay by Bank`,
  payment_methods_open_banking_pis: `Open Banking`,
  payment_methods_evoucher: `E-Voucher`,
  payment_methods_pix_transfer: `Pix`,
  payment_methods_pix_emv_transfer: `PixEmv`,
  payment_methods_boleto: `Boleto`,
  payment_methods_paypal: `Paypal`,
  payment_methods_local_bank_transfer_transfer: `Union Pay`,
  payment_methods_mifinity: `Mifinity`,
  payment_methods_upi_collect: `UPI Collect`,
  payment_methods_eft: `EFT`,
  payment_methods_givex: `Givex`,
  payment_methods_saved_methods: `Saved`,
  giftCardSectionTitle: `Have a gift card?`,
  giftCardNumberLabel: `Gift Card Number`,
  giftCardNumberPlaceholder: `ABCD1234EFGH5678`,
  giftCardNumberEmptyText: `Gift card number cannot be empty`,
  giftCardNumberInvalidText: `Invalid gift card number`,
  giftCardPinLabel: `Gift Card PIN`,
  giftCardPinPlaceholder: `123456`,
  giftCardPinEmptyText: `Gift card PIN cannot be empty`,
  giftCardPinInvalidText: `Invalid gift card PIN`,
  cardText: `Card`,
  giftCardAppliedText: `applied`,
  giftCardPaymentCompleteMessage: `No remaining amount to pay. Please proceed with payment.`,
  giftCardPaymentRemainingMessage: localeStrings_giftCardPaymentRemainingMessage,
  installmentPayInInstallments: "Pay in installments",
  installmentInterestFree: "Interest free",
  installmentWithInterest: "with interest",
  installmentTotal: "Total",
  installmentSelectPlanError: "Please select an installment plan",
  installmentSelectPlanPlaceholder: "Select installment plan",
  showMore: "Show more",
  showLess: "Show less",
  refreshingText: "Refreshing...",
  paymentDetailsBeingCheckedText: "Payment details are being checked. Please wait"
};

export {
  localeStrings,
}
/* react/jsx-runtime Not a pure module */
